import { useQuery } from '@tanstack/react-query';
import {
  ProductBehavior,
  type ProductDto,
  ProductsApi,
} from '@up2stay/up2promo-api-client';
import { behaviorTypeToProductType } from '@up2stay/up2promo-commons/products';

const LINKED_PRODUCTS_LIMIT = 100;

export type LinkedProductSummary = {
  id: string;
  hash: string;
  description?: string | null;
  productType?: string | null;
  targetKind: string;
};

function toLinkedProductSummary(product: ProductDto): LinkedProductSummary {
  return {
    id: product.id,
    hash: product.hash,
    description: product.label ?? null,
    // Where scans lead decides which location link the product relies on.
    productType: behaviorTypeToProductType(
      product.target?.kind ?? product.item.behavior,
    ),
    targetKind: product.target?.kind ?? ProductBehavior.URL,
  };
}

export function useLocationLinkedProducts(
  workspaceId: string | undefined,
  locationId: string | undefined,
) {
  return useQuery({
    queryKey: ['location-linked-products', workspaceId, locationId],
    queryFn: async (): Promise<LinkedProductSummary[]> => {
      if (!workspaceId || !locationId) return [];
      const res = await ProductsApi.findAll({
        path: { workspaceId },
        query: {
          locationId,
          page: 1,
          limit: LINKED_PRODUCTS_LIMIT,
        },
      });
      return (res.data?.data ?? []).map(toLinkedProductSummary);
    },
    enabled: !!workspaceId && !!locationId,
    staleTime: 30_000,
  });
}
